import React, { Component, Fragment } from "react";
import { Field, reduxForm } from "redux-form";
import S from "string";
//constants
import { usStates } from "../../../../constants/app";
//utils
import { renderField, renderSelectField } from "../../../../utils/forms";
//antd
import { Button, Col, Row } from "antd";

import { push } from "react-router-redux";

const fields = ["name", "pc_first_name", "pc_last_name", "pc_email", "status"];

const statusOptions = [
  { text: "Active", value: "active" },
  { text: "On-boarding", value: "on-boarding" },
  { text: "Deactivated", value: "deactivated" }
];

const companySizeOptions = [
  { value: '50', text: 'Less than 50 employees' },
  { value: '100', text: '50 to 100 employees' },
  { value: '500', text: '100 to 500 employees' },
  { value: '1000', text: '500 to 1000 employees' },
  { value: '5000', text: '1000 to 5000 employees' },
  { value: '5000+', text: 'More than 5000 employees' },
];

const validate = values => {
  const errors = {};
  fields.forEach(field => {
    if (!values[field]) {
      errors[field] = `${S(field).humanize().s} required`;
    }
  });
  return errors;
};


export class CompanyForm extends Component {
  state = {
    deleting: false
  };

  _delete = () => {
    const { deleteCompany } = this.props;
    let confirmDelete = window.confirm("Confirm Delete Company");
    if (confirmDelete) {
      this.setState({
        deleting: true
      });
      deleteCompany();
    }
  };

  _backToList = () => {
    const { redirect } = this.props;
    redirect('/companies');
  };

  render() {

    const { handleSubmit, deleteCompany } = this.props;

    return (
      <form onSubmit={handleSubmit}>
        <Row type="flex" justify="center">
          <Col span={4}>
            <Field
              name="status"
              type="text"
              component={renderSelectField}
              label="Status"
              options={statusOptions}
            />
          </Col>
        </Row>
        <div style={{ height: "30px" }} />
        <Row gutter={12}>
          <Col span={12}>
            <Field
              placeholder="Company Name"
              label="Company Name"
              name="name"
              component={renderField}
              type="text"
            />
          </Col>
          <Col span={12}>
            <Field
              placeholder="Linkedin Url"
              label="Linkedin Url"
              name="linkedin_url"
              component={renderField}
              type="text"
            />
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Field
              placeholder="Industry"
              label="Industry"
              name="industry"
              component={renderField}
              type="text"
            />
          </Col>
          <Col span={12}>
            <Field
              placeholder="Website Url"
              label="Website Url"
              name="website_url"
              component={renderField}
              type="text"
            />
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}>
            <Field
              placeholder="City"
              label="City"
              name="city"
              component={renderField}
              type="text"
            />
          </Col>
          <Col span={6}>
            <Field
              name="state"
              type="text"
              component={renderSelectField}
              label="State"
              placeholder="State"
              options={usStates}
            />
          </Col>
          <Col span={6}>
            <Field
              placeholder="No Of Employees"
              label="# Employees"
              name="number_of_employees"
              component={renderSelectField}
              options={companySizeOptions}
              type="text"
            />
          </Col>
        </Row>
        {(this.props.initialValues && !this.state.deleting) ? (
          <Row type="flex" justify="center">
            <Col md={12}>
              {this.state.deleting ? <div>Deleting...</div> : (
                <Fragment>
                  <Button style={{ width: "30%" }} type="primary" htmlType="submit">
                    Update Company
                  </Button>
                  <Button style={{ width: "30%", marginLeft: "5px" }} onClick={this._delete} type="danger">
                    Delete Company
                  </Button>
                  <Button style={{ width: "30%", marginLeft: "5px" }} onClick={this._backToList} >
                    Back to List
                  </Button>
                </Fragment>
              )}
            </Col>
          </Row>
        ) : (
          <Row type="flex" justify="center">
            <Col md={12}>
              <Button style={{ width: "45%" }} type="primary" htmlType="submit">
                Add Company
              </Button>
              <Button style={{ width: "45%", marginLeft: "5px" }} onClick={this._backToList} >
                Back to List
              </Button>
            </Col>
          </Row>
        )
        }
      </form >
    );
  };
};

export default reduxForm({
  form: "company-edit",
  validate
})(CompanyForm);



// WEBPACK FOOTER //
// ./src/components/dashboard/company/forms/new.js